const formLang = {
  label: {
    dateFormat: {
      en: 'dd/mm/yy',
      fr: 'dd/mm/yy'
    },
    email: {
      en: 'Email Address',
      fr: 'Courriel'
    },
    subject: {
      en: 'Please Select Email Subject',
      fr: 'Veuillez choisir le sujet du courriel'
    },
    select: {
      en: 'Please Select',
      fr: 'Veuillez choisir'
    },
    dealerPostal: {
      en: 'Search by Postal Code or Dealer Name',
      fr: 'Recherche par code postal ou nom de concessionnaire'
    },
    firstname: {
      en: 'First Name',
      fr: 'Prénom'
    },
    lastname: {
      en: 'Last Name',
      fr: 'Nom'
    },
    fullname: {
      en: 'Full Name',
      fr: 'Nom complet'
    },    
    postalcode: {
      en: 'Postal Code',
      fr: 'Code postal'
    },
    phone: {
      en: "Phone Number (optional)",
      fr: "Numéro de téléphone (optionnel)"
    },
    vin: {
      en: 'Vehicle Identification Number (VIN)',
      fr: 'Numéro d’identification du véhicule'
    },
    odometer: {
      en: 'Approx. Odometer Reading',
      fr: 'Le nombre approximatif de kilomètres inscrit à l\'odomètre'
    },
    province: {
      en: 'Province',
      fr: 'Province'
    },
    age: {
      en: 'Age',
      fr: 'Âge'
    },
    consent: {
      en: 'I have consent from my parent or guardian (listed above) to participate.*',
      fr: 'J’ai le consentement de mon parent ou tuteur (nommé ci-dessus) pour participer.*'
    },
    vehicleLookUp: {
      en: 'Enter year, make and model',
      fr: 'Entrer l’année, la marque et le modèle'
    },
    kilometers: {
      en: 'Current Kilometres',
      fr: 'Kilométrage actuel'
    },
    model: {
      en: 'Mazda Model',
      fr: 'Modèle Mazda'
    },
    modelYear: {
      en: 'Model year (select model first)',
      fr: 'Modèle et année (sélectionner le modèle d’abord)'
    },
    message2500: {
      en: 'Message (limit 2000 characters) ',
      fr: 'Message (limite de 2000 caractères)'
    },
    message: {
      en: 'Message (optional) ',
      fr: 'Message (optionnel)'
    },
    additionalInfo: {
      en: 'Additional information (limit 2,500 characters)',
      fr: 'Information supplémentaire (limite de 2 500 caractères)'
    },
    expectedPurchaseDate: {
      en: 'Expected Purchase Date',
      fr: 'Date d’achat prévue'
    },
    buildName: {
      en: 'Build Name',
      fr: 'Nom du modèle'
    },
    recipientName: {
      en: "Recipient's Name",
      fr: "Nom du destinatair"
    },
    recipientEmail: {
      en: "Recipient's Email Address",
      fr: "Courriel du destinataire"
    },
    recipientPhone: {
      en: "Recipient's Phone Number",
      fr: "Numéro de téléphone du destinataire"
    },
    modelTrim: {
      en: "Model Trim",
      fr: "Version"
    },
    durationInvolvment: {
      en: "How long have you been dedicated to this cause?*",
      fr: "Depuis combien de temps vous consacrez-vous à cette cause&nbsp;?*"
    },
    howManyHelped: {
      en: "How many people have your efforts helped to date?*",
      fr: "Combien de personnes vos efforts ont-ils permis d’aider à ce jour&nbsp;?*"
    },
    whoBenefitEffort: {
      en: "Describe your contributions (350 words max)*",
      fr: "Décrivez vos contributions (350 mots maximum)*"
    },
    file: {
      en: '+ Upload your media',
      fr: '+ TÉLÉVERSER VOS VIDÉOS/IMAGES'
    },
    fileDesc: {
      en: 'Upload supporting video or image content (optional)',
      fr: 'Téléchargez du contenu vidéo ou visuel complémentaire (facultatif) '
    },
    fileTypes:{
      en: 'Accepted filetypes: MP4, MOV, PDF, JPG, PNG.<br>20MB max size.',
      fr: 'Types de fichiers acceptés : MP4, MOV, PDF, JPG, PNG.<br>Taille maximale de 20 Mo.'
    },
    optional:{
      en: '(Optional)',
      fr: '(Facultatif)'
    },
    preferredContact: {
      en: 'Please select your preferred contact method',
      fr: 'Veuillez sélectionner votre méthode de communication préférée'
    }
  },
  placeholder: {
    model: {
      en: 'Select Mazda Model',
      fr: 'Veuillez choisir un modèle'
    },
    modelTrim: {
      en: 'Select Model Trim',
      fr: 'Choisir une version'
    },
    modelYear: {
      en: 'Please choose a model year',
      fr: 'Veuillez choisir une année'
    },
    subject: {
      en: 'Select Email Subject Content',
      fr: 'Veuillez choisir le sujet du courriel'
    },
    preferredContact:{
      en: 'Please Select',
      fr: 'Veuillez choisir'
    }
  },
  select: {
    expectedPurchaseOptions: [
      {
        en: "Less than 1 month",
        fr: "Moins d’un mois",
      },
      {
        en: "1 to 4 months",
        fr: "1 à 4 mois ",
      },
      {
        en: "5 to 8 months",
        fr: "5 à 8 mois",
      },
      {
        en: "9 to 12 months",
        fr: "9 à 12 mois",
      },
      {
        en: " 1 year or more",
        fr: "Plus d’un an",
      },
      {
        en: "Undecided",
        fr: "Indécis",
      }
    ],
    preferredContact:[
      {
        en: "Email",
        fr: "Courriel",
      },
      {
        en: "Phone Call",
        fr: "Téléphone ",
      },
      {
        en: "SMS/Text",
        fr: "SMS/Texto",
      }
    ],
    emailSubjects: [
      {
        en: "Accessibility",
        fr: "Accessibilité",
      },
      {
        en: "Change of address/Update of ownership",
        fr: "Application MyMazda",
      },
      {

        en: "Connected vehicle",
        fr: "Changement d’adresse / Mise à jour du propriétaire",
      },
      {
        en: "General inquiries",
        fr: "Demandes de service et de garantie",
      },
      {
        en: "Marketing/Sales",
        fr: "Demandes générales",
      },
      {
        en: "Mazda stories magazine",
        fr: "Informations sur les produits",
      },
      {
        en: "MyMazda app",
        fr: "Magazine mazda monde",
      },
      {
        en: "Product information",
        fr: "Marketing / Vente",
      },
      {
        en: "Recall",
        fr: "Plan de remboursement des rappels",
      },
      {
        en: "Recall reimbursement plan",
        fr: "Rappel",
      },
      {
        en: "Service/Warranty inquiries",
        fr: "Véhicule connecté",
      }
    ],
    provinces: [
      {
        en: "Alberta",
        fr: "Alberta",
        enShort:"AB",
        frShort:"AB"
      },
      {
        en: "British Columbia",
        fr: "Colombie-Britannique",
        enShort:"BC",
        frShort:"BC"
      },
      {
        en: "Manitoba",
        fr: "île du Prince-Édouard",
        enShort:"MB",
        frShort:"PE"
      },
      {
        en: "New Brunswick",
        fr: "Manitoba",
        enShort:"NB",
        frShort:"MB"
      },
      {
        en: "Newfoundland and Labrador",
        fr: "Nouveau-Brunswick",
        enShort:"NL",
        frShort:"NB"
      },
      {
        en: "Northwest Territories",
        fr: "Nouvelle-Écosse",
        enShort:"NT",
        frShort:"NS"
      },
      {
        en: "Nova Scotia",
        fr: "Nunavut",
        enShort:"NS",
        frShort:"NU"
      },
      {
        en: "Nunavut",
        fr: "Ontario",
        enShort:"NU",
        frShort:"ON"
      },
      {
        en: "Ontario",
        fr: "Québec",
        enShort:"ON",
        frShort:"QC"
      },
      {
        en: "Prince Edward Island",
        fr: "Saskatchewan",
        enShort:"PE",
        frShort:"SK"
      },
      {
        en: "Quebec",
        fr: "Terre-Neuve-et-Labrador",
        enShort:"QC",
        frShort:"NL"
      },
      {
        en: "Saskatchewan",
        fr: "Territoires du Nord-Ouest",
        enShort:"SK",
        frShort:"NT"
      },
      {
        en: "Yukon",
        fr: "Yukon",
        enShort:"YT",
        frShort:"YT"
      },
    ],
  },
  
  checkboxes: {
    services: {
      maintenance: {
        en: "Scheduled Maintenance Service",
        fr: "Entretien périodique",
      },
      brakeRepair: {
        en: "Brake Inspection/Repair",
        fr: "Inspection ou réparation des freins",
      },
      windshieldRepair: {
        en: "Windshield Repair",
        fr: "Réparation de pare-brise",
      },
      wheelAlignment: {
        en: "Wheel Alignment",
        fr: "Réglage de la géométrie",
      },
      tireRotation: {
        en: "Tire Rotation",
        fr: "Permutation des pneus",
      },
      tireInstallation: {
        en: "Installation of Seasonal Tires",
        fr: "Installation saisonnière des pneus",
      },
      tireInspection: {
        en: "Tire Inspection/Replacement",
        fr: "Inspection ou remplacement des pneus",
      },
      other: {
        en: "Other",
        fr: "Autre",
      },
    },
  },
}

export default formLang;